'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRedux = require('react-redux');

var _HeroBanner = require('acq-components/lib/composite-components/HeroBanner/HeroBanner');

var _ReadyToApplyPrimaryContainer = require('acq-components/lib/composite-components/HeroBanner/variants/IntlCommercial/ReadyToApplyPrimaryContainer');

var _ReadyToApplyImageContainer = require('acq-components/lib/composite-components/HeroBanner/variants/IntlCommercial/ReadyToApplyImageContainer');

var _Typography = require('acq-components/lib/base-components/Typography/Typography');

var _Link = require('acq-components/lib/base-components/Link/Link');

var _FullWidthBackground = require('acq-components/lib/composite-components/FullWidthBackground/FullWidthBackground');

var _dtmConsts = require('acq-components/lib/utils/DTM/dtmConsts');

var _ApplyModal = require('../ApplyModal/ApplyModal');

var _ApplyModal2 = _interopRequireDefault(_ApplyModal);

var _componentHelpers = require('../../utils/component-helpers');

var _reinforcementBanner = require('../../redux/selectors/reinforcementBanner');

var selectors = _interopRequireWildcard(_reinforcementBanner);

var _common = require('../../redux/selectors/common');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReinforcementBannerWrapper = function ReinforcementBannerWrapper(_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      dtmHelper = _ref.dtmHelper,
      shadeAlternator = _ref.shadeAlternator,
      shouldFlipPhoneNumber = _ref.shouldFlipPhoneNumber,
      props = (0, _objectWithoutProperties3.default)(_ref, ['styles', 'dtmHelper', 'shadeAlternator', 'shouldFlipPhoneNumber']);

  if (!props.hasReinforcementBannerData) return null;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      showModal = _useState2[0],
      setModalState = _useState2[1];

  var openModal = function openModal() {
    return setModalState(true);
  };
  var closeModal = function closeModal() {
    return setModalState(false);
  };

  var primaryButtonKey = props.primaryButtonKey;
  var useModal = primaryButtonKey === 'modal';
  var primaryButtonOnclick = useModal ? openModal : undefined;
  var primaryButtonHref = useModal ? undefined : dtmHelper.getUrlByLinkObj(props.primaryButtonURL, _dtmConsts.DTM_CONSTS.readytoapply);

  var secondaryButtonClickHandler = null;

  if (!props.secondaryButtonTitle || props.secondaryButtonTitle === props.compareHoverTitle) {
    secondaryButtonClickHandler = (0, _componentHelpers.getCompareButtonOnClickHandler)({
      compareLink: props.compareLink,
      dtmHelper: dtmHelper,
      cardShortName: props.cardShortName,
      section: _dtmConsts.DTM_CONSTS.bottom
    });
  }

  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      _FullWidthBackground.FullWidthBackground,
      {
        styles: styles.fullWidthBackground,
        isDarkShade: shadeAlternator.isShaded(),
        isImageRepeated: true,
        backgroundImgUrl: props.backgroundImgUrl.url
      },
      _react2.default.createElement(_HeroBanner.HeroBanner, {
        styles: styles.readyToApply,
        PrimaryContentComponent: _ReadyToApplyPrimaryContainer.ReadyToApplyPrimaryContainer,
        primaryContentProps: {
          buttonContainerClassname: styles.readyToApply.buttonsContainer,
          titleComponent: {
            headerText: props.titleComponentHeaderText
          },
          titleComponentStyles: styles.readyToApply,
          TitleComponentTag: 'h2',
          textComponents: {
            headerDescriptionText: (0, _componentHelpers.concactDescStr)(props.headerDescriptionText, '<br/>'),
            phoneNumber: shouldFlipPhoneNumber ? (0, _componentHelpers.concactDescStr)(props.phoneNumberLabel) : props.phoneNumber,
            phoneNumberLabel: shouldFlipPhoneNumber ? props.phoneNumber : (0, _componentHelpers.concactDescStr)(props.phoneNumberLabel)
          },
          textComponentStyles: (0, _extends3.default)({}, styles.readyToApply, {
            phoneNumber: shouldFlipPhoneNumber ? styles.readyToApply.phoneNumberLabel : styles.readyToApply.phoneNumber,
            phoneNumberLabel: shouldFlipPhoneNumber ? styles.readyToApply.phoneNumber : styles.readyToApply.phoneNumberLabel
          }),
          primaryButtonProps: {
            Component: props.primaryButtonText ? _Link.Link : function () {
              return null;
            },
            children: props.primaryButtonText,
            href: primaryButtonHref,
            dtm: props.primaryButtonDTM,
            className: styles.readyToApply.link,
            title: props.primaryButtonTitle || props.speakToSpecialistHoverTitle,
            onClick: primaryButtonOnclick
          },
          secondaryButtonProps: {
            Component: props.secondaryButtonText ? _Link.Link : function () {
              return null;
            },
            children: props.secondaryButtonText,
            href: dtmHelper.getUrlByLinkObj(props.secondaryButtonURL, _dtmConsts.DTM_CONSTS.readytoapply),
            dtm: secondaryButtonClickHandler ? null : props.secondaryButtonDTM,
            className: styles.readyToApply.link,
            title: props.secondaryButtonTitle || props.compareHoverTitle,
            onClick: secondaryButtonClickHandler
          }
        },
        SecondaryContentComponent: _ReadyToApplyImageContainer.ReadyToApplyImageContainer,
        secondaryContentProps: {
          images: props.tiles
        },
        TertiaryContentComponent: props.disclaimer.length ? _Typography.Typography : undefined,
        tertiaryContentProps: {
          className: styles.readyToApply.disclaimer,
          components: [props.disclaimer]
        },
        namespace: 'ready-to-apply',
        qeId: props.qeId
      })
    ),
    showModal && _react2.default.createElement(_ApplyModal2.default, {
      styles: styles,
      closeModal: closeModal,
      dtmHelper: dtmHelper
    })
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    hasReinforcementBannerData: selectors.getHasReinforcementBanner(state),
    cardShortName: selectors.getCardShortName(state),
    compareLink: (0, _common.getCompareLink)(state),
    backgroundImgUrl: selectors.getBackgroundImgUrl(state),
    titleComponentHeaderText: selectors.getTitleComponentHeaderText(state),
    headerDescriptionText: selectors.getHeaderDescriptionText(state),
    phoneNumber: selectors.getPhoneNumber(state),
    phoneNumberLabel: selectors.getPhoneNumberLabel(state),
    primaryButtonText: selectors.getPrimaryButtonText(state),
    primaryButtonURL: selectors.getPrimaryButtonURL(state),
    primaryButtonDTM: selectors.getPrimaryButtonDTM(state),
    primaryButtonTitle: selectors.getPrimaryButtonTitle(state),
    primaryButtonKey: selectors.getPrimaryButtonKey(state),
    secondaryButtonText: selectors.getSecondaryButtonText(state),
    secondaryButtonURL: selectors.getSecondaryButtonURL(state),
    secondaryButtonDTM: selectors.getSecondaryButtonDTM(state),
    secondaryButtonTitle: selectors.getSecondaryButtonTitle(state),
    disclaimer: selectors.getDisclaimer(state),
    compareHoverTitle: (0, _common.getCompareHoverTitle)(state),
    speakToSpecialistHoverTitle: selectors.getSpeakToSpecialistHoverTitle(state),
    tiles: selectors.getTiles(state),
    qeId: selectors.getQeId(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ReinforcementBannerWrapper);